import React, { useState } from "react";
import { Alert, Button, Input, Modal, Space, Typography } from "antd";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { readOrdersEdifact } from "../../../../../urls";
import { getFirebaseIDToken } from "../../../../../functions/firebase/firebase";

const { Text } = Typography;
const { TextArea } = Input;

/**
 * Modal waarin een gebruiker een ruw EDIFACT ORDERS-bericht (D:96A, EAN008)
 * kan plakken. Op "Parse" wordt het bericht naar de backend gestuurd, die het
 * omzet naar een farmorder-preview (zelfde vervolgstap als de Excel-import:
 * PreviewExcelOrdersModal).
 */
const ImportEdifactOrderModal = ({ visible, onCancel, onParsed }) => {
  const { t } = useTranslation();
  const [rawMessage, setRawMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleClose = () => {
    setRawMessage("");
    setError(null);
    onCancel();
  };

  const handleParse = async () => {
    if (!rawMessage.trim()) {
      setError(t("edifact_message_required"));
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const token = await getFirebaseIDToken();
      const { data } = await axios.post(
        readOrdersEdifact,
        { message: rawMessage },
        { headers: { Authorization: token } },
      );

      setRawMessage("");
      onParsed(data);
    } catch (err) {
      setError(err.response?.data?.message || err.message || t("edifact_parse_failed"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={t("import_edifact_order_title")}
      open={visible}
      onCancel={handleClose}
      footer={[
        <Button key="cancel" onClick={handleClose}>
          {t("cancel")}
        </Button>,
        <Button key="parse" type="primary" loading={loading} onClick={handleParse}>
          {t("parse_message")}
        </Button>,
      ]}
      width={700}
    >
      <Space direction="vertical" style={{ width: "100%" }} size="middle">
        <Text type="secondary">{t("import_edifact_order_message")}</Text>
        <TextArea
          value={rawMessage}
          onChange={(e) => setRawMessage(e.target.value)}
          placeholder={"UNB+UNOA:3+...'\nUNH+...+ORDERS:D:96A:UN:EAN008'\n..."}
          autoSize={{ minRows: 12, maxRows: 20 }}
          style={{ fontFamily: "monospace", fontSize: 12 }}
        />
        {error && <Alert type="error" showIcon message={error} />}
      </Space>
    </Modal>
  );
};

export default ImportEdifactOrderModal;
